import fetch from 'model/auth/ApiAuth'
import Utils from 'utils';
import {PUBLIC_REQUEST_KEY} from "../../auth/FetchInterceptor";
import ITokenResponse from "../../interface/security/ITokenResponse";
import axios from "axios";

const tokenService = {
    retrieve: (username: string, password: string): Promise<ITokenResponse> => {
        // @ts-ignore
        return fetch({
            url: '/token',
            method: 'post',
            data: Utils.convertArrayToFormData({
                username,
                password
            }),
            headers: {
                "Content-Type": "multipart/form-data",
                [PUBLIC_REQUEST_KEY]: 'true'
            }
        })
    },
    additionalAuthorization: (user: string, code?: string, reset?: true): Promise<ITokenResponse> => {
        // @ts-ignore
        return fetch({
            url: '/token-additional',
            method: 'post',
            data: Utils.convertArrayToFormData({
                user,
                code,
                reset
            }),
            headers: {
                "Content-Type": "multipart/form-data",
                [PUBLIC_REQUEST_KEY]: 'true'
            }
        })
    },
    google: (token: string): Promise<ITokenResponse> => {
        // @ts-ignore
        return fetch({
            url: '/token',
            method: 'post',
            data: Utils.convertArrayToFormData({
                token,
                authority: 'google'
            }),
            headers: {
                "Content-Type": "multipart/form-data",
                [PUBLIC_REQUEST_KEY]: 'true'
            }
        })
    },
    facebook: (token: string): Promise<ITokenResponse> => {
        // @ts-ignore
        return fetch({
            url: '/token',
            method: 'post',
            data: Utils.convertArrayToFormData({
                token,
                authority: 'facebook'
            }),
            headers: {
                "Content-Type": "multipart/form-data",
                [PUBLIC_REQUEST_KEY]: 'true'
            }
        })
    },
    ldap: (username: string, password: string): Promise<ITokenResponse> => {
        // @ts-ignore
        return fetch({
            url: '/token',
            method: 'post',
            data: Utils.convertArrayToFormData({
                username,
                password,
                authority: 'ldap'
            }),
            headers: {
                "Content-Type": "multipart/form-data",
                [PUBLIC_REQUEST_KEY]: 'true'
            }
        })
    },
    sso(): Promise<ITokenResponse> {
        // @ts-ignore
        return axios.get('/sso.php', {
            withCredentials: true // This ensures cookies are sent and received
        })
            .then(response => {
                if (response.data.status === 'authenticated') {
                    const user = response.data.user;
                    console.log('Authenticated as:', user);

                    // Step 2: Call your token endpoint
                    return fetch({
                        url: '/token',
                        method: 'post',
                        data: Utils.convertArrayToFormData({
                            authority: 'sso'
                        }),
                        headers: {
                            "Content-Type": "multipart/form-data",
                            [PUBLIC_REQUEST_KEY]: 'true'
                        },
                        withCredentials: true // This ensures cookies are sent and received
                    }).catch(e => {
                        return e
                    })
                } else {
                    throw new Error('NTLM authentication failed.');
                }
            })
            .catch(error => {
                console.error('Authentication or token request failed:', error);
                //still try to load again
                return axios.get('/sso.php', {
                    withCredentials: true // This ensures cookies are sent and received
                })
                    .then(response => {
                        if (response.data.status === 'authenticated') {
                            const user = response.data.user;
                            console.log('Authenticated as:', user);

                            // Step 2: Call your token endpoint
                            return fetch({
                                url: '/token',
                                method: 'post',
                                data: Utils.convertArrayToFormData({
                                    authority: 'sso'
                                }),
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    [PUBLIC_REQUEST_KEY]: 'true'
                                },
                                withCredentials: true // This ensures cookies are sent and received
                            }).catch(e => {
                                return e
                            })
                        } else {
                            throw new Error('NTLM authentication failed.');
                        }
                    })
                    .catch(error => {
                        console.error('Authentication or token request failed:', error);
                        //still try to load
                        return fetch({
                            url: '/token',
                            method: 'post',
                            data: Utils.convertArrayToFormData({
                                authority: 'sso'
                            }),
                            headers: {
                                "Content-Type": "multipart/form-data",
                                [PUBLIC_REQUEST_KEY]: 'true'
                            },
                            withCredentials: true // This ensures cookies are sent and received
                        })
                    });
            });
    }
}

export default tokenService